import React from 'react';

import useArrayHalves from '@/hooks/use-array-halves';
import { useGlobalContext } from '@/hooks/use-global-context';

import Carousel, { CarouselVariant } from '@/features/carousel';
import {
  InfiniteCarouselDirection,
  InfiniteCarouselProps,
} from '@/features/carousel/components/infinite-carousel';
import { JobBlocksHighPayingJobsProps } from '@/features/job-blocks';
import CardHighPayingJob from '@/features/job-blocks/components/card-high-paying-job';
import { HighPayingJobsResponse } from '@/services/high-paying-jobs.service';
import { transformJobDisciplineTitle } from '@/services/transformers/public-jobs-transformer';

export default function JobBlocksHighPaying(_: JobBlocksHighPayingJobsProps) {
  const { pageStaticData } = useGlobalContext();
  const groupHighPayingJobs = useArrayHalves(
    pageStaticData?.highPayingJobs || []
  );

  const highPayingJobsToCarouselItem = (
    props: HighPayingJobsResponse[number]
  ) => ({
    id: props.id,
    component: (
      <CardHighPayingJob
        job={{
          id: props.id,
          weeklyPay: props.weekly_pay,
          location: {
            city: props.city,
            state: props.state,
          },
          shift: props.shift,
          specialty: props.specialty,
          discipline: props.discipline,
          disciplineTitle: transformJobDisciplineTitle(props.discipline),
          title: props.title,
          code: props.code,
        }}
      />
    ),
  });

  const commonProps: Omit<InfiniteCarouselProps, 'direction' | 'items'> = {
    variant: CarouselVariant.INFINITE,
    pauseOnHover: true,
    heightClassName: 'h-36',
  };

  return (
    <div className='flex flex-col'>
      <Carousel
        {...commonProps}
        direction={InfiniteCarouselDirection.LEFT_TO_RIGHT}
        speed='slow'
        items={groupHighPayingJobs[0].map(highPayingJobsToCarouselItem)}
      />
      <Carousel
        {...commonProps}
        direction={InfiniteCarouselDirection.RIGHT_TO_LEFT}
        speed='very-slow'
        items={groupHighPayingJobs[1].map(highPayingJobsToCarouselItem)}
      />
    </div>
  );
}
